import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import { useSelector } from 'react-redux';
import ImageUpload from '../../../components/common/ImageUpload';
import { MdAddCircleOutline } from 'react-icons/md';
import { IoIosClose } from 'react-icons/io';

import { CategoryType } from '../../../models/type.model';
import { useNavigate, useParams } from 'react-router-dom';
import SelectDropdown from '../../../components/common/SelectDropdown';
import statusModel from '../../../models/status.model';
import { Tooltip } from 'antd';
import { toast } from 'react-toastify';
import methodModel from '../../../methods/methods';
import Layout from '../../../components/global/layout';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Select } from 'react-select';

const AddEditBlogs = () => {
  const [images, setImages] = useState({ image: '', banner: '', icon: '' });
  const defaultvalue = CategoryType;
  const { id, type } = useParams();
  const [tagData, setTagData] = useState(null);
  const [Tag, setTag] = useState([]);
  const [num, setnum] = useState([]);
  const [data, setdata] = useState([]);
  const [form, setform] = useState({
    meta_keywords: '',
    image: [],
    alt_tag: [],
    category_id: '',
    description: '',
    meta_title: '',
    title: '',
  });
  const [categories, setCategories] = useState([]);
  const [tab, setTab] = useState('info');
  const history = useNavigate();
  const [submitted, setSubmitted] = useState(false);
  const [Types, setTypes] = useState();
  const user = useSelector((state) => state.user);
  const formValidation = [{ key: 'title', required: true }];

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    // if (form.url && !/^https?:\/\//.test(form.url)) {
    //   return
    // }
    let invalid = methodModel.getFormError(formValidation, form);
    if (tab == 'seo' && invalid) {
      toast.error('Please fill Required Fields');
    }
    if (!form?.description || !form?.image?.length) {
      return;
    }
    const formattedUrl = form?.url?.startsWith('https://') ? form?.url : `https://${form?.url}`;

    if (invalid) return;
    let method = 'post';
    let url = 'blogs';
    let value = {
      ...form,
      url: formattedUrl
      // image: form?.image,
      // title: form?.title,
      // meta_title: form?.meta_title,
      // category_id: `${form?.category_id}`,
      // description: form?.description,
      // meta_keywords: form?.meta_keywords,
      // alt_tag: Tag,
    };
    if (id) {
      method = 'put';
      url = 'blogs';
      value.id = JSON.parse(id);
    } else {
      // value.addedBy = user._id;
      delete value.id;
    }

    loader(true);
    ApiClient.allApi(url, value, method).then((res) => {
      if (res.success) {
        history('/products');
      }
      loader(false);
    });
  };

  const imageResult = (e, key) => {
    // images[key] = e.value;
    // setImages(images);
    setImages(e?.value);
    setform({ ...form, image: e?.value });
  };

  const getCategory = (t = type) => {
    ApiClient.get('CommonCategory/all', {
      page: 1,
      count: 100,
      type: 'blog',
      status: 'active',
    }).then((res) => {
      if (res.success) {
        setCategories(res.data);
      }
    });
  };

  const CategoryChange = (e) => {
    let ext = categories.find((itm) => itm.id == e);
    let value = null;
    if (ext && ext.parentCategory) value = ext.parentCategory._id;
    return value;
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    if (id) {
      loader(true);
      ApiClient.get('blogs', { id }).then((res) => {
        if (res.success) {
          let value = res.data;
          setTag(res?.data?.alt_tag);
          setform((prev) => ({
            ...prev,
            title: res.data?.title,
            meta_title: res.data?.meta_title,
            description: res.data?.description,
            image: res.data?.image,
            id: res.data?.id,
            alt_tag: res.data?.alt_tag,
            meta_keywords: res.data?.meta_keywords,
            url: res.data?.url,
            category_id: res.data?.category_id?.id,
          }));
        }
        loader(false);
      });
    }
  }, [id]);

  useEffect(() => {
    getCategory();
  }, []);
  const getTypes = () => {
    ApiClient.get(`api/categorytype/listing`, { status: 'active' }).then(
      (res) => {
        if (res.success) {
          setTypes(res.data);
        }
      }
    );
  };

  const removetag = (i, index) => {
    let arr = [...Tag];
    let fltr = arr?.filter((itm, key) => key != i);
    setTag(fltr);
    setform({
      ...form,
      alt_tag: fltr,
    });

    setnum(num - 1);
  };

  const updatetag = (i, key, value, index) => {
    let arr = [...Tag];
    // let obj = {};
    // obj[key] = value;
    arr[i] = value;
    setTag([...arr]);
    setform({
      ...form,
      alt_tags: [...arr],
    });
    setnum(arr.length);
  };

  const AddTag = (i) => {
    let arr = [...Tag];
    arr.push('');
    setTag([...arr]);
  };
  useEffect(() => {
    // getTypes();
  }, []);

  return (
    <>
      <Layout>
        <form onSubmit={handleSubmit}>
          <div className="pprofile1 shadow-lg">
            <div className="flex items-center mb-8">
              <Tooltip placement="top" title="Back">
                <button
                  type="button"
                  onClick={(e) => back()}
                  className="!px-4  py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all   discard mr-3"
                >
                  <i className="fa fa-angle-left text-lg"></i>
                </button>
              </Tooltip>
              <div>
                <h3 className="text-2xl font-semibold text-[#111827]">
                  {id ? ' Edit ' : ' Add '}
                  Recommended Product
                </h3>
                <p class="text-sm font-normal text-[#525252]">
                  Here you can see all about your Recommended Product
                </p>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4">
              {tab == 'info' ? (
                <>
                  <div className="col-span-12 md:col-span-6">
                    <label>
                      Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.title}
                      onChange={(e) =>
                        setform((prev) => ({ ...prev, title: e.target.value }))
                      }
                      required
                    />
                  </div>

                  {!type ? (
                    <div className="col-span-12 md:col-span-6">
                      <label>
                        Type<span className="star">*</span>
                      </label>
                      <div className="custom_dropdown">
                        <SelectDropdown
                          id="statusDropdown"
                          displayValue="name"
                          placeholder="Select Type"
                          intialValue={form?.category_id}
                          theme="search"
                          required
                          result={(e) => {
                            setform({
                              ...form,
                              category_id: e?.value,
                            });
                            // getCategory(e.value);
                          }}
                          options={categories}
                        />
                        {/* <select
                          className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                          value={form?.category_id}
                          onChange={e => setform({ ...form, category_id: e.target.value })}
                        >
                          <option value="">Select Type</option>
                          {categories.map((itm) => <option value={itm?.id}>{itm?.name}</option>)}
                        </select> */}
                        {submitted && !form?.category_id ? (
                          <div className="text-danger">
                            Category is Required
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="col-span-12 md:col-span-6">
                    <label>Url</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.url}
                      onChange={(e) =>
                        setform((prev) => ({
                          ...prev,
                          url: e.target.value,
                        }))
                      }
                    />
                    {/* {submitted && form.url && !/^https?:\/\//.test(form.url) ? (
                      <div className="invalid-feedback d-block">
                        Please include "http://" or "https://"
                      </div>
                    ) : (
                      <></>
                    )} */}

                  </div>

                  <div className="col-span-12 md:col-span-6">
                    <label>Meta Title</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.meta_title}
                      onChange={(e) =>
                        setform((prev) => ({
                          ...prev,
                          meta_title: e.target.value,
                        }))
                      }
                    />
                  </div>

                  {/* {Tag?.map((itm, i) => {
                    return (
                      <div className="col-span-6 md:col-span-6">
                        <div
                          className=""
                          onChange={(e) => {
                            if (num > data[0]?.sizeOfVenue) {
                              removetag(i, index);
                            }
                          }}
                        >
                          <label>ALT Tag</label>

                          <div className="flex items-center">
                            <input
                              type="text"
                              className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                              value={itm}
                              onChange={
                                (e) => {
                                  updatetag(i, '', e.target.value);
                                }
                                // setform({ ...form, name: e.target.value })
                              }
                            />
                            {i < 1 ? null : (
                              <i
                                className="fa fa-trash text-danger pointer ml-2"
                                onClick={(e) => removetag(i)}
                              ></i>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                  <div className="col-span-12 md:col-span-12">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={() => {
                        AddTag();
                      }}
                    >
                      <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                      Add Alt Tag
                    </button>
                  </div> */}
                  <div className="col-span-12 md:col-span-6">
                    <label>ALT Tags</label>
                    <div className="flex items-center relative">
                      <input
                        type="text"
                        className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                        value={tagData}
                        onChange={
                          (e) => setTagData(e.target.value)

                          // setform({ ...form, meta_keywords: e.target.value })
                        }
                      />
                      <div className="text-[#e5e7eb] bg-[#A12238] pointer flex justify-center items-center w-[40px] h-[40px] border-l-[1px] border-[#e5e7ea] rounded-lg  right-0 absolute">
                        <MdAddCircleOutline
                          className="w-[25px]"
                          onClick={() => {
                            let arr = [...Tag];
                            arr.push(tagData);
                            setform({
                              ...form,
                              alt_tag: arr,
                            });
                            setTag(arr);
                            setTagData('');
                          }}
                          size={30}
                        />
                      </div>
                    </div>
                    <div className="flex gap-1 flex-wrap mt-1">
                      {form?.alt_tag?.map((itm, i) => {
                        return (
                          <p className="flex gap-2 items-center border border-[1px] rounded-md bg-[#A12238] text-[12px] text-[#fff] w-fit py-[4px] px-2">
                            {itm}
                            <IoIosClose
                              className="text-[18px] cursor-pointer"
                              onClick={() => {
                                removetag(i);
                              }}
                            />
                          </p>
                        );
                      })}
                    </div>
                  </div>

                  <div className="col-span-12 md:col-span-6">
                    <label>Meta Keywords</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form?.meta_keywords}
                      onChange={(e) =>
                        setform({ ...form, meta_keywords: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-span-12 md:col-span-12 mb-3">
                    <label>
                      Description<span className="star">*</span>
                    </label>
                    <ReactQuill
                      theme="snow"
                      // defaultValue={form?.description}
                      value={form?.description}
                      onChange={(e) => {
                        setform((prev) => ({ ...prev, description: e }));
                      }}
                    />

                    {submitted && !form.description ? (
                      <div className="invalid-feedback d-block">
                        Description is Required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                  {/* <div className="col-span-12 md:col-span-6">
                    <label>Parent Category</label>
                    <div className="custom_dropdown">
                      <SelectDropdown
                        id="statusDropdown"
                        displayValue="name"
                        placeholder="Set as Parent"
                        intialValue={form.parentCategory}
                        result={(e) => {
                          setform({ ...form, parentCategory: e.value });
                        }}
                        options={categories}
                        theme="search"
                      />
                    </div>
                  </div> */}

                  {/* <div className="col-span-12 md:col-span-6">
                    <label>
                      Status<span className="star">*</span>
                    </label>
                    <div className="custom_dropdown">
                      <SelectDropdown
                        id="statusDropdown"
                        displayValue="name"
                        placeholder="Select Status"
                        intialValue={form.status}
                        result={(e) => {
                          setform({ ...form, status: e.value });
                        }}
                        options={statusModel.list}
                      />
                      {submitted && !form.status ? (
                        <div className="text-danger">Status is Required</div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div> */}

                  <div className="col-span-12 md:col-span-12">
                    <label className="lablefontcls">
                      Image<span className="star">*</span>
                    </label>
                    <br></br>
                    <ImageUpload
                      model="users"
                      result={(e) => imageResult(e, 'image')}
                      value={images.image || form.image}
                      multiple={true}
                    />
                    {submitted && !form?.image?.length ? (
                      <div className="invalid-feedback d-block">
                        Image is required
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              ) : (
                <>
                  <div className="col-span-12 md:col-span-12">
                    <label>URL Key</label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.urlKey}
                      onChange={(e) =>
                        setform({ ...form, urlKey: e.target.value })
                      }
                    />
                    <div className="small">Leave empty to auto generate</div>
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Title<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaTitle}
                      onChange={(e) =>
                        setform({ ...form, metaTitle: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Meta Description<span className="star">*</span>
                    </label>
                    <textarea
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.metaDescription}
                      onChange={(e) =>
                        setform({ ...form, metaDescription: e.target.value })
                      }
                      required
                    />
                  </div>
                  <div className="col-span-12 md:col-span-12">
                    <label>
                      Keywords<span className="star">*</span>
                    </label>
                    <input
                      type="text"
                      className="relative shadow-box bg-white w-full rounded-lg h-10 flex items-center gap-2 overflow-hidden focus-visible:outline-0 px-2"
                      value={form.keywords}
                      onChange={(e) =>
                        setform({ ...form, keywords: e.target.value })
                      }
                      required
                    />
                  </div>
                </>
              )}
            </div>
            <div className="flex justify-end">
              <button
                type="submit"
                className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:opacity-80 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
              >
                Save
              </button>
            </div>
          </div>
        </form>
      </Layout>
    </>
  );
};

export default AddEditBlogs;
